import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../utils/translations';
import {RequestText} from '../RequestText/RequestText';
import {ReservationTracker} from './ReservationTracker/ReservationTracker';
import {Button} from '@homeaway/react-buttons';
import edap from '@homeaway/edap-wrapper';
import {BOOKING_CONFIRMATION} from '../../../../utils/edapUtils';
import {INBOX_URL} from '../../../constants';

import './ReservationSteps.less';

export class ReservationSteps extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
        hostName: PropTypes.string,
        instantBooking: PropTypes.bool.isRequired,
        isIpm: PropTypes.bool,
        isVrbexNative: PropTypes.bool,
        isVrboIpmStaticMessaging: PropTypes.bool,
        reservationId: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
        tripDetailsUrl: PropTypes.string,
    };

    static defaultProps = {
        translations: {},
    };

    onClickViewTripDetails() {
        edap().push({
            name: 'generic.click',
            data: {
                eventaction: 'trip.details.click',
                eventcategory: 'traveler activity',
                eventlabel: 'reservation cta',
            },
        });
    }
    onClickViewInbox(reservationId) {
        edap().push({
            name: 'inbox.selected',
            data: {
                eventcategory: 'traveler activity',
                eventaction: 'go.to.inbox.clicked',
                eventlabel: 'Go to Inbox cta',
                action_location: 'booking_confirmation',
                pagename: 'travelerdash booking confirmation',
                attributes: reservationId,
            },
        });
    }

    render() {
        const {
            hostName,
            isIpm,
            isVrbexNative,
            isVrboIpmStaticMessaging,
            reservationId,
            translations,
            tripDetailsUrl,
        } = this.props;
        const hideConfirmedMoreText = isIpm && isVrboIpmStaticMessaging;

        return (
            <div
                className={`ReservationSteps col-sm-12 ${
                    hideConfirmedMoreText ? '' : 'col-md-offset-2 col-md-8'
                }`}
            >
                <RequestText
                    email={this.props.email}
                    hostName={hostName}
                    instantBooking={this.props.instantBooking}
                    isIpm={isIpm}
                    isVrbexNative={isVrbexNative}
                    isVrboIpmStaticMessaging={isVrboIpmStaticMessaging}
                    reservationId={reservationId}
                    translations={translations}
                    tripDetailsUrl={tripDetailsUrl}
                />
                {!isVrbexNative ? (
                    <div>
                        <ReservationTracker
                            actionLocation={BOOKING_CONFIRMATION}
                            translations={translations}
                        />
                        <Button
                            className="ReservationSteps__button"
                            href={tripDetailsUrl}
                            label={translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.confirmation.cta'
                            )}
                            onClick={this.onClickViewTripDetails}
                        />
                        {!hideConfirmedMoreText && (
                            <div>
                                {translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.confirmation.request.confirmed.more'
                                )}
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: translate(
                                    translations,
                                    'trav-dash/trav-home',
                                    'messages',
                                    'th.confirmation.request.confirmation.more.vrbexNativeText'
                                ),
                            }}
                        />
                        <Button
                            className="ReservationSteps__button"
                            href={INBOX_URL}
                            label={translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'modifyBooking.confirmation.goToInboxButton'
                            )}
                            onClick={this.onClickViewInbox(reservationId)}
                        />
                    </div>
                )}
            </div>
        );
    }
}
